import Modal from "../../../../../../../components/Modal/Modal";
import Button from "../../../../../../../components/Button/Button";
import DeleteTrashOpenIcon from "../../../../../../../assets/svg/delete-trash-open-icon";
import AlertIcon from "../../../../../../../assets/svg/alert-icon";

export interface DeleteHelpdeskCustomFieldModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  isDeleting?: boolean;
}

export function DeleteHelpdeskCustomFieldModal({
  open,
  onOpenChange,
  onConfirm,
  isDeleting,
}: DeleteHelpdeskCustomFieldModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      preventOutsideClick={false}
      customHeader={
        <div className="flex items-center gap-2.5 flex-1 min-w-0">
          <DeleteTrashOpenIcon className="w-4 h-4 shrink-0 text-verba-red-alert dark:text-verba-red-alert-dk" />
          <span className="text-heading-text dark:text-heading-text-dk font-medium text-base leading-normal">
            Delete Custom Field
          </span>
        </div>
      }
      headerClassName="px-5 pt-5 pb-0"
      contentClassName="w-[360px] max-w-[calc(100vw-2rem)] border border-border-gray dark:border-border-gray-dk bg-fixed-white dark:bg-popper-bg-dk backdrop-blur-[10px] rounded-[10px]"
      overlayClassName="bg-black/80"
      bodyClassName="!p-0"
      closeOnEscape={!isDeleting}
    >
      <div
        className="flex flex-col gap-10 px-5 pb-5 pt-1"
        onClick={(e) => e?.stopPropagation()}
      >
        <div className="mt-4 rounded-[8px] border border-border-gray dark:border-border-gray-dk bg-applied-filters-tag-bg/30 dark:bg-applied-filters-tag-bg-dk/30 p-2.5">
          <div className="flex gap-3 items-start">
            <AlertIcon className="mt-1 w-[18px] h-[18px] shrink-0 text-verba-red-alert dark:text-verba-red-alert-dk" />
            <p className="text-md font-normal text-data dark:text-data-dk">
              Deletion of this custom field will delete all related saved views.
              This action cannot be undone.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2.5 flex-wrap">
          <Button
            type="button"
            innerText="Cancel"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
            buttonContainerClass="min-w-[100px] min-h-[26px] py-[2px] px-2 text-md border border-verba-indigo dark:border-verba-indigo-dk hover:border-transparent bg-verba-indigo text-pure-white dark:text-pure-white-dk dark:bg-verba-indigo-dk rounded-md cursor-pointer hover:bg-verba-blue dark:hover:bg-verba-blue-dk hover:text-fixed-white-light-and-dark-mode dark:hover:text-fixed-white-light-and-dark-mode-dk transition-colors duration-200"
            innerTextClass="text-md font-semibold"
          />
          <Button
            type="button"
            innerText={isDeleting ? "Deleting..." : "Delete Custom Field"}
            onClick={() => void onConfirm()}
            disabled={isDeleting}
            buttonContainerClass="disabled:opacity-30 min-w-[100px] min-h-[26px] py-[2px] px-6 text-md border border-verba-red-alert dark:border-verba-red-alert-dk bg-transparent dark:bg-transparent rounded-md cursor-pointer text-verba-red-alert dark:text-verba-red-alert-dk hover:bg-verba-red-alert dark:hover:bg-verba-red-alert-dk hover:text-fixed-white-light-and-dark-mode dark:hover:text-fixed-white-light-and-dark-mode-dk transition-colors duration-200 disabled:hover:bg-transparent disabled:hover:text-verba-red-alert disabled:hover:dark:text-verba-red-alert-dk dark:disabled:hover:bg-transparent"
            innerTextClass="text-md font-semibold"
          />
        </div>
      </div>
    </Modal>
  );
}
